export default __webpack_public_path__ + "static/media/videocamera.b7a9e3c8.jpg";